module.exports = __webpack_public_path__ + "img/77.642674a0.jpg";